





































import { mixins } from 'vue-class-component'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import AppSteps from '@/components/AppSteps.vue'
import ContactFormRecordType from '@/modules/Contact/components/forms/ContactFormRecordType.vue'
import ContactFormAccount from '@/modules/Contact/components/forms/ContactFormAccount.vue'
import ContactFormInfo from '@/modules/Contact/components/forms/ContactFormInfo.vue'
import ContactFormSource from '@/modules/Contact/components/forms/ContactFormSource.vue'
import RecordTypesHandler from '@/mixins/record-types'
import { newContact, editContact } from '@/modules/Contact/gql/contact.gql'
import { Account } from '@/modules/Account/interfaces/account'
import { Contact } from '@/modules/Contact/interfaces/contact'
import { IContactRecordTypeInput, IContactInfoInput, IContactSourceInput, IContactAccountInput } from '@/modules/Contact/interfaces/contact-form'
import delNonNumCode from '@/utils/delNonNumCode'
import { states } from '@/utils/us_states'
import {
  salutation,
  salutationKeys,
  salutationValues
} from '@/modules/Contact/helpers/contact'

@Component({
  components: {
    ContactFormRecordType,
    ContactFormAccount,
    ContactFormInfo,
    AppDialog,
    ContactFormSource,
    AppSteps
  }
})
export default class ContactForm extends mixins(RecordTypesHandler) {
  @Prop(Boolean) value!: boolean
  @Prop(Number) readonly step!: number
  @Prop(String) readonly title!: string
  @Prop({ type: Object as () => Account }) readonly account!: Account
  @Prop({ type: Object as () => Contact }) readonly contact!: Contact

  showDialog = false
  loading = false

  recordTypeIndex = 0
  stepIndex = 0

  recordTypeInput: IContactRecordTypeInput = {
    recordType: {}
  }

  accountInput: IContactAccountInput = {
    name: '',
    account: {},
    salutationIdx: -1,
    title: '',
    doNotCall: false,
    textOptOut: false,
    emailOptOut: false
  }

  infoInput: IContactInfoInput = {
    phone: '',
    otherPhone: '',
    mobile: '',
    fax: '',
    email: '',
    otherEmail: '',
    department: '',
    extension: '',
    otherAddressCountry: '',
    otherAddressStateIdx: -1,
    otherAddressCity: '',
    otherAddressStreet: '',
    otherAddressPostalCode: '',
    mailingAddressCountry: '',
    mailingAddressStateIdx: -1,
    mailingAddressCity: '',
    mailingAddressStreet: '',
    mailingAddressPostalCode: ''
  }

  sourceInput: IContactSourceInput = {
    source: {}
  }

  steps = [
    ['Record Type', 680, 461],
    ['Account Info', 770, 421],
    ['Contact Info', 770, 885],
    ['Source Info', 770, 301]
  ]

  get stepItems () {
    return this.steps.map(st => st[0])
  }

  get hightLightTitle () {
    return this.recordTypeInput.recordType.name ? ' (' + this.recordTypeInput.recordType.name + ')' : ''
  }

  get showBackBtn () {
    return this.stepIndex > 0
  }

  get confirmText () {
    return this.stepIndex < this.steps.length - 1
      ? 'Next'
      : this.contact
        ? 'Save'
        : 'Create'
  }

  get confirmAheadText () {
    return this.contact ? 'Save' : 'Create'
  }

  get canPost () {
    return this.stepIndex > 0 && this.stepIndex < this.steps.length - 1
  }

  @Watch('value')
  onValueChanged (val: boolean) {
    if (val) {
      this.resetStep()
      this.initInput()
    }
    this.showDialog = val
  }

  resetStep () {
    this.stepIndex = this.step
  }

  initInput () {
    if (this.contact) {
      const {
        name, salutation, title, doNotCall, textOptOut, emailOptOut,
        phone, countryCode, extensionNumber, countryCallingCode,
        otherPhone, otherCountryCode, otherExtensionNumber, otherCountryCallingCode,
        mobile, mobileCountryCode, mobileExtensionNumber, mobileCountryCallingCode,
        fax, faxCountryCode, faxExtensionNumber, faxCountryCallingCode,
        email, otherEmail, department, extension,
        otherAddressCountry, otherAddressState, otherAddressCity, otherAddressStreet, otherAddressPostalCode, mailingAddressCountry, mailingAddressState, mailingAddressCity, mailingAddressStreet, mailingAddressPostalCode,
        accountName, recordType, source
      } = this.contact

      this.recordTypeInput = {
        recordType: {
          id: +recordType.id,
          name: recordType.name
        }
      }
      this.accountInput = {
        name,
        account: {
          name: accountName ? accountName.name : '',
          id: accountName ? +accountName.id : undefined
        },
        salutationIdx: salutationKeys.findIndex(item => item === salutation),
        title,
        doNotCall,
        textOptOut,
        emailOptOut
      }
      this.infoInput = {
        phone: (countryCode || '') + ',' + (phone || '') + ',' + (extensionNumber || '') + ',' + (countryCallingCode || ''),
        otherPhone: (otherCountryCode || '') + ',' + (otherPhone || '') + ',' + (otherExtensionNumber || '') + ',' + (otherCountryCallingCode || ''),
        fax: (faxCountryCode || '') + ',' + (fax || '') + ',' + (faxExtensionNumber || '') + ',' + (faxCountryCallingCode || ''),
        mobile: (mobileCountryCode || '') + ',' + (mobile || '') + ',' + (mobileExtensionNumber || '') + ',' + (mobileCountryCallingCode || ''),
        otherAddressCountry,
        otherAddressStateIdx: states.findIndex(state => state === otherAddressState),
        otherAddressCity,
        otherAddressStreet,
        otherAddressPostalCode,
        mailingAddressCountry,
        mailingAddressStateIdx: states.findIndex(state => state === mailingAddressState),
        mailingAddressCity,
        mailingAddressStreet,
        mailingAddressPostalCode,
        email,
        otherEmail,
        department,
        extension
      }

      this.sourceInput = {
        source: {
          id: source ? +source.id : undefined,
          name: source ? source.name : ''
        }
      }
    } else {
      this.clearForm()
    }

    if (this.account) {
      this.accountInput = {
        ...this.accountInput,
        account: {
          name: this.account.name,
          id: +this.account.id
        }

      }
    }
  }

  handleStepClick (index: number) {
    if (!this.contact) {
      return
    }

    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    this.stepIndex = index
  }

  onRecordTypeChanged (index: number) {
    this.recordTypeIndex = index
  }

  handleValidate () {
    const { stepIndex, steps } = this
    const refName = steps[stepIndex][0] as string
    return (this.$refs[refName] as Vue & {
      validate: () => null | { [key: string]: number | string }
    }).validate()
  }

  handleConfirm (event: Event, finishAhead = false) {
    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    if (this.stepIndex === this.steps.length - 1 || finishAhead) {
      this.loading = true
      if (this.contact) {
        this.handleUpdate()
      } else {
        this.handleCreate()
      }
    } else {
      this.stepIndex += 1
    }
  }

  handleBack () {
    if (this.stepIndex > 0) {
      this.stepIndex -= 1
    } else {
      this.showDialog = false
    }
  }

  async handleCreate () {
    const {
      recordTypeInput: { recordType: { id: recordTypeId } },
      accountInput: {
        name, account: { id: accountId }, salutationIdx,
        doNotCall, textOptOut, emailOptOut, title
      },
      infoInput: {
        phone, otherPhone, fax, mobile,
        otherAddressCountry, otherAddressStateIdx, otherAddressCity, otherAddressStreet, otherAddressPostalCode,
        mailingAddressCountry, mailingAddressStateIdx, mailingAddressCity, mailingAddressStreet, mailingAddressPostalCode,
        email, otherEmail, department, extension
      },
      sourceInput: { source: { id: sourceId } }
    } = this

    const phoneArr = phone.split(',')
    const otherPhoneArr = otherPhone.split(',')
    const mobileArr = mobile.split(',')
    const faxArr = fax.split(',')

    try {
      const res = await this.$apollo.mutate({
        mutation: newContact,
        variables: {
          accountId: this.account ? +this.account.id : null,
          contactInput: {
            accountId: accountId || null,
            name,
            title,
            salutation: salutationKeys[salutationIdx] || null,
            recordTypeId,
            doNotCall,
            textOptOut,
            emailOptOut,
            department,
            extension,
            phone: delNonNumCode(phoneArr[1] || ''),
            extensionNumber: phoneArr[2] || '',
            countryCode: phoneArr[0] || '',
            countryCallingCode: phoneArr[3] || '',
            otherPhone: delNonNumCode(otherPhoneArr[1] || ''),
            otherExtensionNumber: otherPhoneArr[2] || '',
            otherCountryCode: otherPhoneArr[0] || '',
            otherCountryCallingCode: otherPhoneArr[3] || '',
            fax: delNonNumCode(faxArr[1] || ''),
            faxExtensionNumber: faxArr[2] || '',
            faxCountryCode: faxArr[0] || '',
            faxCountryCallingCode: faxArr[3] || '',
            mobile: delNonNumCode(mobileArr[1] || ''),
            mobileExtensionNumber: mobileArr[2] || '',
            mobileCountryCode: mobileArr[0] || '',
            mobileCountryCallingCode: mobileArr[3] || '',
            otherAddressCountry,
            otherAddressState: states[otherAddressStateIdx] || '',
            otherAddressPostalCode,
            otherAddressCity,
            otherAddressStreet,
            mailingAddressCountry,
            mailingAddressState: states[mailingAddressStateIdx] || '',
            mailingAddressPostalCode,
            mailingAddressCity,
            mailingAddressStreet,
            email,
            otherEmail,
            additionalInfo: this.parseAdditionalInfo(),
            sourceId
          }
        }
      })
      this.clearForm()
      this.onSuccess('Create the new account successfully', res.data.newContact)
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  async handleUpdate () {
    const {
      recordTypeInput: { recordType: { id: recordTypeId } },
      accountInput: {
        name, account: { id: accountId }, salutationIdx,
        doNotCall, textOptOut, emailOptOut, title
      },
      infoInput: {
        phone, otherPhone, fax, mobile,
        otherAddressCountry, otherAddressStateIdx, otherAddressCity, otherAddressStreet, otherAddressPostalCode,
        mailingAddressCountry, mailingAddressStateIdx, mailingAddressCity, mailingAddressStreet, mailingAddressPostalCode,
        email, otherEmail, department, extension
      },
      sourceInput: { source: { id: sourceId } }
    } = this

    const phoneArr = phone.split(',')
    const otherPhoneArr = otherPhone.split(',')
    const mobileArr = mobile.split(',')
    const faxArr = fax.split(',')

    try {
      const res = await this.$apollo.mutate({
        mutation: editContact,
        variables: {
          contactId: +this.contact.id,
          contactInput: {
            accountId: accountId || null,
            name,
            title,
            salutation: salutationKeys[salutationIdx] || null,
            recordTypeId,
            doNotCall,
            textOptOut,
            emailOptOut,
            department,
            extension,
            phone: delNonNumCode(phoneArr[1] || ''),
            extensionNumber: phoneArr[2] || '',
            countryCode: phoneArr[0] || '',
            countryCallingCode: phoneArr[3] || '',
            otherPhone: delNonNumCode(otherPhoneArr[1] || ''),
            otherExtensionNumber: otherPhoneArr[2] || '',
            otherCountryCode: otherPhoneArr[0] || '',
            otherCountryCallingCode: otherPhoneArr[3] || '',
            fax: delNonNumCode(faxArr[1] || ''),
            faxExtensionNumber: faxArr[2] || '',
            faxCountryCode: faxArr[0] || '',
            faxCountryCallingCode: faxArr[3] || '',
            mobile: delNonNumCode(mobileArr[1] || ''),
            mobileExtensionNumber: mobileArr[2] || '',
            mobileCountryCode: mobileArr[0] || '',
            mobileCountryCallingCode: mobileArr[3] || '',
            otherAddressCountry,
            otherAddressState: states[otherAddressStateIdx] || '',
            otherAddressPostalCode,
            otherAddressCity,
            otherAddressStreet,
            mailingAddressCountry,
            mailingAddressState: states[mailingAddressStateIdx] || '',
            mailingAddressPostalCode,
            mailingAddressCity,
            mailingAddressStreet,
            email,
            otherEmail,
            additionalInfo: this.parseAdditionalInfo(),
            sourceId
          }
        }
      })
      this.clearForm()
      this.onSuccess('Update account successfully')
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  parseAdditionalInfo () {
    return '{}'
  }

  clearForm () {
    this.loading = false
    this.recordTypeInput = {
      recordType: {}
    }
    this.accountInput = {
      name: '',
      account: {},
      salutationIdx: -1,
      title: '',
      doNotCall: false,
      textOptOut: false,
      emailOptOut: false
    }
    this.infoInput = {
      phone: '',
      otherPhone: '',
      mobile: '',
      fax: '',
      email: '',
      otherEmail: '',
      department: '',
      extension: '',
      otherAddressCountry: '',
      otherAddressStateIdx: -1,
      otherAddressCity: '',
      otherAddressStreet: '',
      otherAddressPostalCode: '',
      mailingAddressCountry: '',
      mailingAddressStateIdx: -1,
      mailingAddressCity: '',
      mailingAddressStreet: '',
      mailingAddressPostalCode: ''
    }

    this.sourceInput = {
      source: {}
    }
  }

  @Emit('cancel')
  handleCancel () {
    this.$emit('input', false)
    this.clearForm()
  }

  @Emit('success')
  onSuccess (msg = '', contact?: Contact) {
    this.$emit('input', false)
    this.resetStep()
    if (msg) {
      showNotification({
        msg,
        type: SnackType.Success
      })
    }

    return contact
  }
}
